import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { generate } from 'shortid';

import TableHeader, { TableHeaderItem } from './TableHeader';
import TableRow from './TableRow';
import parentStyles from '../../utils/parentStyles';

export interface Subtext {
  label: string;
  styles: Record<string, any>;
}

export interface TableItem {
  label: string;
  styles: Record<string, any>;
  subtexts: Subtext[];
}

interface TableProps {
  title?: string | null;
  headerItems?: TableHeaderItem[];
  bodyItems?: TableItem[][];
}

const Table: React.FC<TableProps> = ({
  title = null,
  headerItems = [],
  bodyItems = []
}) => (
  <View>
    <View fixed wrap={false}>
      <View style={parentStyles.title}>{title && <Text>{title}</Text>}</View>
      {headerItems.length > 0 && <TableHeader items={headerItems} />}
    </View>
    {bodyItems.map((row, index) => (
      <TableRow
        key={`table-row-${generate()}`}
        items={row}
        showBorder={index + 1 < bodyItems.length}
      />
    ))}
  </View>
);

export default Table;
